// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/e2e/[userId]/cx-qc/page"
import { usePageHead } from "../../../../compat/head"

export const Route = createFileRoute("/e2e/$userId/cx-qc/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "CX-QC — Sales Execution Score" })
  const params = Route.useParams()
  const search = Route.useSearch()
  const pageProps: any = { params: Promise.resolve(params), searchParams: Promise.resolve(search) }
  return <Page {...pageProps} />
}
